export default __webpack_public_path__ + "static/media/totalleavesvector.a6565637.svg";